<template>
	<div class="padding-lr rel" style="height: 100%">
		<template v-if="currentType == 'detail'">
			<el-page-header @back="handleCloseDialog2" :content="approveForm.OrderedName"></el-page-header>
			<div class="condition">
				<div class="item">
					<span>审批流程：</span>
					<span class="margin-left">{{approveForm.FlowchartName}}</span>
				</div>
				<div class="item">
					<span>申请类型：</span>
					<span class="margin-left">{{approveForm.ApplicantType}}</span>
				</div>
				<div class="item">
					<span>林地类型：</span>
					<span class="margin-left">{{approveForm.FellableType}}</span>
				</div>
			</div>
			<el-scrollbar style="height: 85%" ref="scrollbar">
				<table class="margin-top xlsTable" >
					<thead>
						<th colspan="12">林木采伐许可证核发申请表</th>
					</thead>
					<tbody>
						<tr>
						  <td>向哪一级单位申请</td>
						  <td>省/自治区/直辖市</td>
							<td>{{approveForm.ApplyProvince}}</td>
							<td>市</td>
							<td colspan="2">{{approveForm.ApplyCity}}</td>
							<td>县(市、区)</td>
							<td colspan="2">{{approveForm.ApplyRegion}}</td>
							<td>乡/镇</td>
							<td colspan="2">{{approveForm.ApplyTown}}</td>
						</tr>
						<tr>
						  <td>项目名称</td>
							<td colspan="11">{{approveForm.ProjectName}}</td>
						</tr>
						<tr>
						  <td>申请单位(个人)名称</td>
							<td colspan="2">{{approveForm.Applicant}}</td>
							<td colspan="2">法定代表人姓名</td>
							<td>{{approveForm.LegalPerson}}</td>
							<td colspan="3">统一社会信用代码(身份证号)</td>
							<td colspan="3">{{approveForm.OperatorID}}</td>
						</tr>
						<tr>
						  <td>申请单位(个人)地址</td>
							<td>省/自治区/直辖市</td>
							<td>{{approveForm.Province}}</td>
							<td>市</td>
							<td>{{approveForm.City}}</td>
							<td>县(市、区)</td>
							<td>{{approveForm.Region}}</td>
							<td colspan="5"></td>
						</tr>
						<tr>
						  <td>联系人姓名</td>
							<td>{{approveForm.ContactsName}}</td>
							<td>联系人手机号</td>
							<td colspan="3">{{approveForm.ContactsPhone}}</td>
							<td>联系人身份证号</td>
							<td colspan="3">{{approveForm.ContactsIdCard}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
						  <td>林木权属类型</td>
							<td colspan="2">{{approveForm.OwnershipType}}</td>
							<td>国有单位类型</td>
							<td colspan="2">{{approveForm.CountryUnitType}}</td>
							<td>木材类别</td>
							<td colspan="3">{{approveForm.WoodType}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
						  <td>不动产(林权)证书编号或林权证号</td>
							<td colspan="5">{{approveForm.RealEstateCode}}</td>
							<td>其他林木权属证明</td>
							<td colspan="5">{{approveForm.OtherOwnership}}</td>
						</tr>
						<tr>
						  <td rowspan="12">采伐</td>
							<td>地点</td>
							<td>乡/林场</td>
							<td>{{approveForm.Town}}</td>
							<td>村/分场</td>
							<td>{{approveForm.Village}}</td>
							<td>屯</td>
							<td>{{approveForm.Group}}</td>
							<td>林班/作业区</td>
							<td>{{approveForm.LinBan}}</td>
							<td>小班</td>
							<td>{{approveForm.XiaoBan}}</td>
						</tr>
						<tr>
							<td>小地名</td>
							<td colspan="10">{{approveForm.Toponym}}</td>
						</tr>
						<tr>
							<td>采伐四至</td>
							<td>东:</td>
							<td>{{approveForm.East}}</td>
							<td>西:</td>
							<td>{{approveForm.West}}</td>
							<td>南:</td>
							<td>{{approveForm.South}}</td>
							<td>北:</td>
							<td>{{approveForm.North}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
							<td>GPs定位</td>
							<td>东:</td>
							<td>{{approveForm.EastGPS}}</td>
							<td>西:</td>
							<td>{{approveForm.WestGPS}}</td>
							<td>南:</td>
							<td>{{approveForm.SouthGPS}}</td>
							<td>北:</td>
							<td>{{approveForm.NorthGPS}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
							<td>面积(公顷)</td>
							<td>{{approveForm.Area}}</td>
							<td>起源</td>
							<td>{{approveForm.Origin}}</td>
							<td>森林类别</td>
							<td>{{approveForm.ForestType}}</td>
							<td>二级林种</td>
							<td colspan="2">{{approveForm.SecondTree}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
							<td>优势树种</td>
							<td>{{approveForm.AdvantageTree}}</td>
							<td>林龄(年)</td>
							<td>{{approveForm.ForestAge}}</td>
							<td>蓄积量(m³)</td>
							<td>{{approveForm.Accumulate}}</td>
							<td>出材量(m³)</td>
							<td>{{approveForm.MateriaOutput}}</td>
							<td>株数</td>
							<td>{{approveForm.PlantNumber}}</td>
							<td></td>
						</tr>
						<tr>
							<td>采伐用途</td>
							<td>{{approveForm.LoggingPurpose}}</td>
							<td>采伐类型</td>
							<td>{{approveForm.LoggingType}}</td>
							<td>采伐方式</td>
							<td colspan="2">{{approveForm.LoggingMethod}}</td>
							<td>蓄积强度(%)</td>
							<td>{{approveForm.AccumulativeStrength}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
							<td rowspan="4">其他采伐树种</td>
							<td>树种1</td>
							<td>{{approveForm.TreeOne}}</td>
							<td>林龄(年</td>
							<td>{{approveForm.TreeOneAge}}</td>
							<td>蓄积量(m³)</td>
							<td>{{approveForm.TreeOneAccumulate}}</td>
							<td>出材量(m³)</td>
							<td>{{approveForm.TreeOneMateriaOutput}}</td>
							<td>株数</td>
							<td>{{approveForm.TreeOnePlantNumber}}</td>
						</tr>
						<tr>
							<td>树种2</td>
							<td>{{approveForm.TreeTwo}}</td>
							<td>林龄(年</td>
							<td>{{approveForm.TreeTwoAge}}</td>
							<td>蓄积量(m³)</td>
							<td>{{approveForm.TreeTwoAccumulate}}</td>
							<td>出材量(m³)</td>
							<td>{{approveForm.TreeTwoMateriaOutput}}</td>
							<td>株数</td>
							<td>{{approveForm.TreeTwoPlantNumber}}</td>
						</tr>
						<tr>
							<td>树种3</td>
							<td>{{approveForm.TreeThree}}</td>
							<td>林龄(年</td>
							<td>{{approveForm.TreeThreeAge}}</td>
							<td>蓄积量(m³)</td>
							<td>{{approveForm.TreeThreeAccumulate}}</td>
							<td>出材量(m³)</td>
							<td>{{approveForm.TreeThreeMateriaOutput}}</td>
							<td>株数</td>
							<td>{{approveForm.TreeThreePlantNumber}}</td>
						</tr>
						<tr>
							<td>树种4</td>
							<td>{{approveForm.TreeFour}}</td>
							<td>林龄(年</td>
							<td>{{approveForm.TreeFourAge}}</td>
							<td>蓄积量(m³)</td>
							<td>{{approveForm.TreeFourAccumulate}}</td>
							<td>出材量(m³)</td>
							<td>{{approveForm.TreeFourMateriaOutput}}</td>
							<td>株数</td>
							<td>{{approveForm.TreeFourPlantNumber}}</td>
						</tr>
						<tr>
							<td colspan="3">采伐总蓄积量(m³)</td>
							<td>{{approveForm.TotalAccumulate}}</td>
							<td colspan="3">采伐总出材量(m³)</td>
							<td>{{approveForm.TotalMateriaOutput}}</td>
							<td colspan="2">总株数</td>
							<td>{{approveForm.TotalPlantNumber}}</td>
						</tr>
						<tr>
							<td rowspan="2">更新</td>
							<td>树种</td>
							<td>{{approveForm.UpdateTree}}</td>
							<td>面积(公顷)</td>
							<td>{{approveForm.UpdateArea}}</td>
							<td>株数</td>
							<td>{{approveForm.UpdatePlantNumber}}</td>
							<td>方式</td>
							<td colspan="2">{{approveForm.UpdateOrigin}}</td>
							<td colspan="2"></td>
						</tr>
						<tr>
							<td colspan="2">完成时间</td>
							<td colspan="2">{{approveForm.EndYear}}</td>
							<td>年</td>
							<td colspan="2">{{approveForm.EndMonth}}</td>
							<td>月</td>
							<td colspan="2">{{approveForm.EndDay}}</td>
							<td>日</td>
						</tr>
						<tr>
							<td>负责伐区调查设备单位</td>
							<td colspan="4">{{approveForm.Designer}}</td>
							<td>技术负责人姓名</td>
							<td colspan="2">{{approveForm.TechnicianName}}</td>
							<td>联系手机</td>
							<td colspan="3">{{approveForm.TechnicianPhone}}</td>
							
						</tr>
						<tr>
							<td>备注</td>
							<td colspan="11">{{approveForm.Remarks}}</td>
						</tr>
						<tr>
							<td>林地性质</td>
							<td>是否公益林</td>
							<td>{{approveForm.IsEcoReserves}}</td>
							<td>是否自然保护区</td>
							<td>{{approveForm.IsNaturalReserve}}</td>
							<td>是否饮用水源保护区</td>
							<td>{{approveForm.IsWaterReserve}}</td>
							<td>是否林权抵押</td>
							<td>{{approveForm.IsForestMortgage}}</td>
							<td colspan="3"></td>
						</tr>
					</tbody>
				</table>
				<div class="margin-top">
					<div class="flex align-center">
						<div style="flex: 1;display: flex;align-items: center;">
							<span style="width: 100px;">图形数据</span>
							<div class="flex align-center margin-left-sm">
								<div v-for="(item, index) in approveForm.SHPPaths">
									<a :href="item.FileAddress">{{item.FileName}}</a>
								</div>
							</div>
						</div>
						<div  style="flex: 1;display: flex;align-items: center;">
							<span style="width: 100px;">资料附件</span>
							<div class="flex align-center margin-left-sm">
								<div v-for="(item, index) in approveForm.FilePaths">
									<a :href="item.FileAddress">{{item.FileName}}</a>
								</div>
							</div>
						</div>
					</div>
					
					<div class="flex align-center margin-top">
						<div style="flex: 1;display: flex;align-items: center;">
							<span style="width: 100px;">检疫文件</span>
							<div class="flex align-center margin-left-sm">
								<div v-for="(item, index) in approveForm.QuarantinePaths">
									<a :href="item.FileAddress">{{item.FileName}}</a>
								</div>
							</div>
						</div>
						<div  style="flex: 1;display: flex;align-items: center;">
							<span style="width: 100px;">实地照片</span>
							<showImages  :imgs="approveForm.Indeeds" :ids="approveForm.IndeedImgess" :width="50" :height="50"></showImages>
						</div>
					</div>
					
					<div class="flex align-center margin-top">
						<div style="flex: 1;display: flex;align-items: center;">
							<span style="width: 100px;">优先审批佐证材料</span>
							<div class="flex align-center margin-left-sm">
								<div v-for="(item, index) in approveForm.FirstFilePath">
									<a :href="item.FileAddress">{{item.FileName}}</a>
								</div>
							</div>
						</div>
						<div  style="flex: 1;"></div>
					</div>
				</div>
			</el-scrollbar>
		</template>
		<template v-else>
			<el-page-header @back="handleCloseDialog" content="添加采伐证"></el-page-header>
			<div class="condition">
				<div class="item">
					<span>审批流程：</span>
					<el-select v-model="FlowchartId" placeholder="请选择" filterable class="ipt">
						<el-option v-for="(item,index) in flowChartList" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
				<div class="item">
					<span>申请类型：</span>
					<el-select v-model="ApplicantType" placeholder="请选择" class="ipt">
						<el-option label="个人" value="个人"></el-option>
						<el-option label="企业" value="企业"></el-option>
					</el-select>
				</div>
				<div class="item">
					<span>林地类型：</span>
					<el-select v-model="FellableType" placeholder="请选择" class="ipt">
						<el-option label="林地" value="林地"></el-option>
						<el-option label="非林地" value="非林地"></el-option>
					</el-select>
				</div>
				<div class="item flex justify-end">
					<el-upload
						class="upload-demo"
						accept=".xls,.xlsx"
						:action="action"
						:limit="1"
						:on-change="(file) => {handleChange(file, 6)}"
						:show-file-list="false"
						:file-list="excelData"
						:headers="headers"
						:on-success="success"
						:on-erroe="error"
					>
						<el-button size="small" type="success">EXCEL导入</el-button>
					</el-upload>
					<el-button type="success" style="margin: 0 0 0 30px;" size="small" @click="downLoad">下载导入模板</el-button>
				</div>
			</div>
			<div class="reserveContent">
				<el-scrollbar style="height: 90%" ref="scrollbar">
				<el-form ref="form" :model="form" :rules="rules">
					<table class="margin-top xlsTable" >
						<thead>
							<th colspan="12">林木采伐许可证核发申请表</th>
						</thead>
						<tbody>
							<tr>
							  <td>向哪一级单位申请</td>
							  <td>省/自治区/直辖市</td>
								<td>
									<el-form-item prop="ApplyProvince"><el-input class="pt" v-model="form.ApplyProvince"></el-input></el-form-item>
								</td>
								<td>市</td>
								<td colspan="2">
									<el-form-item prop="ApplyCity"><el-input class="pt" v-model="form.ApplyCity"></el-input></el-form-item>
								</td>
								<td>县(市、区)</td>
								<td colspan="2">
									<el-form-item prop="ApplyRegion"><el-input class="pt" v-model="form.ApplyRegion"></el-input></el-form-item>
								</td>
								<td>乡/镇</td>
								<td colspan="2">
									<el-form-item prop="ApplyTown"><el-input class="pt" v-model="form.ApplyTown"></el-input></el-form-item>
								</td>
							</tr>
							<tr>
							  <td>项目名称</td>
								<td colspan="11">
									<el-form-item prop="ProjectName"><el-input class="pt" v-model="form.ProjectName"></el-input></el-form-item>
								</td>
							</tr>
							<tr>
							  <td>申请单位(个人)名称</td>
								<td colspan="2">
									<el-form-item prop="Applicant"><el-input class="pt" v-model="form.Applicant"></el-input></el-form-item>
								</td>
								<td colspan="2">法定代表人姓名</td>
								<td>
									<el-form-item prop="LegalPerson"><el-input class="pt" v-model="form.LegalPerson"></el-input></el-form-item>
								</td>
								<td colspan="3">统一社会信用代码(身份证号)</td>
								<td colspan="3">
									<el-form-item prop="OperatorID"><el-input class="pt" v-model="form.OperatorID"></el-input></el-form-item>
								</td>
							</tr>
							<tr>
							  <td>申请单位(个人)地址</td>
								<td>省/自治区/直辖市</td>
								<td>
									<el-form-item prop="Province"><el-input class="pt" v-model="form.Province"></el-input></el-form-item>
								</td>
								<td>市</td>
								<td>
									<el-form-item prop="City"><el-input class="pt" v-model="form.City"></el-input></el-form-item>
								</td>
								<td>县(市、区)</td>
								<td>
									<el-form-item prop="Region"><el-input class="pt" v-model="form.Region"></el-input></el-form-item>
								</td>
								<td colspan="5"></td>
							</tr>
							<tr>
							  <td>联系人姓名</td>
								<td>
									<el-form-item prop="ContactsName"><el-input class="pt" v-model="form.ContactsName"></el-input></el-form-item>
								</td>
								<td>联系人手机号</td>
								<td colspan="3">
									<el-form-item prop="ContactsPhone"><el-input class="pt" v-model="form.ContactsPhone"></el-input></el-form-item>
								</td>
								<td>联系人身份证号</td>
								<td colspan="3">
									<el-form-item prop="ContactsIdCard"><el-input class="pt" v-model="form.ContactsIdCard"></el-input></el-form-item>
								</td>
								<td colspan="2"></td>
							</tr>
							<tr>
							  <td>林木权属类型</td>
								<td colspan="2">
									<el-form-item prop="OwnershipType"><el-input class="pt" v-model="form.OwnershipType"></el-input></el-form-item>
								</td>
								<td>国有单位类型</td>
								<td colspan="2">
									<el-form-item prop="CountryUnitType"><el-input class="pt" v-model="form.CountryUnitType"></el-input></el-form-item>
								</td>
								<td>木材类别</td>
								<td colspan="3">
									<el-form-item prop="WoodType"><el-input class="pt" v-model="form.WoodType"></el-input></el-form-item>
								</td>
								<td colspan="2"></td>
							</tr>
							<tr>
							  <td>不动产(林权)证书编号或林权证号</td>
								<td colspan="5">
									<el-form-item prop="RealEstateCode"><el-input class="pt" v-model="form.RealEstateCode"></el-input></el-form-item>
								</td>
								<td>其他林木权属证明</td>
								<td colspan="5">
									<el-form-item prop="OtherOwnership"><el-input class="pt" v-model="form.OtherOwnership"></el-input></el-form-item>
								</td>
							</tr>
							<tr>
							  <td rowspan="12">采伐</td>
								<td>地点</td>
								<td>乡/林场</td>
								<td>
									<el-form-item prop="Town">
										<el-select v-model="form.Town" placeholder="乡镇" filterable clearable @change="getCun">
											<el-option v-for="(item,index) in zhen" :key="index" :label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>村/分场</td>
								<td>
									<el-form-item prop="Village">
										<el-select v-model="form.Village" placeholder="村(社区)" filterable clearable  @change="getTun">
											<el-option v-for="(item,index) in cun" :key="index" :label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>屯</td>
								<td>
									<el-form-item prop="Group">
										<el-select v-model="form.Group" placeholder="屯(组)" filterable clearable>
											<el-option v-for="(item,index) in tun" :key="index" :label="item.name" :value="item.id"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>林班/作业区</td>
								<td>
									<el-form-item prop="LinBan"><el-input class="pt" v-model="form.LinBan"></el-input></el-form-item>
								</td>
								<td>小班</td>
								<td>
									<el-form-item prop="XiaoBan"><el-input class="pt" v-model="form.XiaoBan"></el-input></el-form-item>
								</td>
							</tr>
							<tr>
								<td>小地名</td>
								<td colspan="10">
									<el-form-item prop="Toponym"><el-input class="pt" v-model="form.Toponym"></el-input></el-form-item>
								</td>
							</tr>
							<tr>
								<td>采伐四至</td>
								<td>东:</td>
								<td><el-form-item><el-input class="pt" v-model="form.East"></el-input></el-form-item></td>
								<td>西:</td>
								<td><el-form-item><el-input class="pt" v-model="form.West"></el-input></el-form-item></td>
								<td>南:</td>
								<td><el-form-item><el-input class="pt" v-model="form.South"></el-input></el-form-item></td>
								<td>北:</td>
								<td><el-form-item><el-input class="pt" v-model="form.North"></el-input></el-form-item></td>
								<td colspan="2"></td>
							</tr>
							<tr>
								<td>GPs定位</td>
								<td>东:</td>
								<td><el-form-item prop="eastGPS"><el-input class="pt" v-model="form.EastGPS"></el-input></el-form-item></td>
								<td>西:</td>
								<td><el-form-item prop="westGPS"><el-input class="pt" v-model="form.WestGPS"></el-input></el-form-item></td>
								<td>南:</td>
								<td><el-form-item prop="southGPS"><el-input class="pt" v-model="form.SouthGPS"></el-input></el-form-item></td>
								<td>北:</td>
								<td><el-form-item prop="northGPS"><el-input class="pt" v-model="form.NorthGPS"></el-input></el-form-item></td>
								<td colspan="2"></td>
							</tr>
							<tr>
								<td>面积(公顷)</td>
								<td><el-form-item prop="Area"><el-input class="pt" v-model="form.Area"></el-input></el-form-item></td>
								<td>起源</td>
								<td><el-form-item prop="Origin"><el-input class="pt" v-model="form.Origin"></el-input></el-form-item></td>
								<td>森林类别</td>
								<td><el-form-item prop="ForestType"><el-input class="pt" v-model="form.ForestType"></el-input></el-form-item></td>
								<td>二级林种</td>
								<td colspan="2"><el-form-item prop="SecondTree"><el-input class="pt" v-model="form.SecondTree"></el-input></el-form-item></td>
								<td colspan="2"></td>
							</tr>
							<tr>
								<td>优势树种</td>
								<td><el-form-item prop="AdvantageTree"><el-input class="pt" v-model="form.AdvantageTree"></el-input></el-form-item></td>
								<td>林龄(年)</td>
								<td><el-form-item prop="ForestAge"><el-input class="pt" v-model="form.ForestAge"></el-input></el-form-item></td>
								<td>蓄积量(m³)</td>
								<td><el-form-item prop="Accumulate"><el-input class="pt" v-model="form.Accumulate"></el-input></el-form-item></td>
								<td>出材量(m³)</td>
								<td><el-form-item prop="MateriaOutput"><el-input class="pt" v-model="form.MateriaOutput"></el-input></el-form-item></td>
								<td>株数</td>
								<td><el-form-item prop="PlantNumber"><el-input class="pt" v-model="form.PlantNumber"></el-input></el-form-item></td>
								<td></td>
							</tr>
							<tr>
								<td>采伐用途</td>
								<td><el-form-item prop="LoggingPurpose"><el-input class="pt" v-model="form.LoggingPurpose"></el-input></el-form-item></td>
								<td>采伐类型</td>
								<td><el-form-item prop="LoggingType"><el-input class="pt" v-model="form.LoggingType"></el-input></el-form-item></td>
								<td>采伐方式</td>
								<td colspan="2"><el-form-item prop="LoggingMethod"><el-input class="pt" v-model="form.LoggingMethod"></el-input></el-form-item></td>
								<td>蓄积强度(%)</td>
								<td><el-form-item prop="AccumulativeStrength"><el-input class="pt" v-model="form.AccumulativeStrength"></el-input></el-form-item></td>
								<td colspan="2"></td>
							</tr>
							<tr>
								<td rowspan="4">其他采伐树种</td>
								<td>树种1</td>
								<td><el-form-item><el-input class="pt" v-model="form.TreeOne"></el-input></el-form-item></td>
								<td>林龄(年)</td>
								<td><el-form-item prop="TreeOneAge"><el-input class="pt" v-model="form.TreeOneAge"></el-input></el-form-item></td>
								<td>蓄积量(m³)</td>
								<td><el-form-item prop="TreeOneAccumulate"><el-input class="pt" v-model="form.TreeOneAccumulate"></el-input></el-form-item></td>
								<td>出材量(m³)</td>
								<td><el-form-item prop="TreeOneMateriaOutput"><el-input class="pt" v-model="form.TreeOneMateriaOutput"></el-input></el-form-item></td>
								<td>株数</td>
								<td><el-form-item prop="TreeOnePlantNumber"><el-input class="pt" v-model="form.TreeOnePlantNumber"></el-input></el-form-item></td>
							</tr>
							<tr>
								<td>树种2</td>
								<td><el-form-item><el-input class="pt" v-model="form.TreeTwo"></el-input></el-form-item></td>
								<td>林龄(年)</td>
								<td><el-form-item prop="TreeTwoAge"><el-input class="pt" v-model="form.TreeTwoAge"></el-input></el-form-item></td>
								<td>蓄积量(m³)</td>
								<td><el-form-item prop="TreeTwoAccumulate"><el-input class="pt" v-model="form.TreeTwoAccumulate"></el-input></el-form-item></td>
								<td>出材量(m³)</td>
								<td><el-form-item prop="TreeTwoMateriaOutput"><el-input class="pt" v-model="form.TreeTwoMateriaOutput"></el-input></el-form-item></td>
								<td>株数</td>
								<td><el-form-item prop="TreeTwoPlantNumber"><el-input class="pt" v-model="form.TreeTwoPlantNumber"></el-input></el-form-item></td>
							</tr>
							<tr>
								<td>树种3</td>
								<td><el-form-item><el-input class="pt" v-model="form.TreeThree"></el-input></el-form-item></td>
								<td>林龄(年)</td>
								<td><el-form-item prop="TreeThreeAge"><el-input class="pt" v-model="form.TreeThreeAge"></el-input></el-form-item></td>
								<td>蓄积量(m³)</td>
								<td><el-form-item prop="TreeThreeAccumulate"><el-input class="pt" v-model="form.TreeThreeAccumulate"></el-input></el-form-item></td>
								<td>出材量(m³)</td>
								<td><el-form-item prop="TreeThreeMateriaOutput"><el-input class="pt" v-model="form.TreeThreeMateriaOutput"></el-input></el-form-item></td>
								<td>株数</td>
								<td><el-form-item prop="TreeThreePlantNumber"><el-input class="pt" v-model="form.TreeThreePlantNumber"></el-input></el-form-item></td>
							</tr>
							<tr>
								<td>树种4</td>
								<td><el-form-item><el-input class="pt" v-model="form.TreeFour"></el-input></el-form-item></td>
								<td>林龄(年)</td>
								<td><el-form-item prop="TreeFourAge"><el-input class="pt" v-model="form.TreeFourAge"></el-input></el-form-item></td>
								<td>蓄积量(m³)</td>
								<td><el-form-item prop="TreeFourAccumulate"><el-input class="pt" v-model="form.TreeFourAccumulate"></el-input></el-form-item></td>
								<td>出材量(m³)</td>
								<td><el-form-item prop="TreeFourMateriaOutput"><el-input class="pt" v-model="form.TreeFourMateriaOutput"></el-input></el-form-item></td>
								<td>株数</td>
								<td><el-form-item prop="TreeFourPlantNumber"><el-input class="pt" v-model="form.TreeFourPlantNumber"></el-input></el-form-item></td>
							</tr>
							<tr>
								<td colspan="3">采伐总蓄积量(m³)</td>
								<td><el-form-item prop="TotalAccumulate"><el-input class="pt" v-model="form.TotalAccumulate"></el-input></el-form-item></td>
								<td colspan="3">采伐总出材量(m³)</td>
								<td><el-form-item prop="TotalMateriaOutput"><el-input class="pt" v-model="form.TotalMateriaOutput"></el-input></el-form-item></td>
								<td colspan="2">总株数</td>
								<td><el-form-item prop="TotalPlantNumber"><el-input class="pt" v-model="form.TotalPlantNumber"></el-input></el-form-item></td>
							</tr>
							<tr>
								<td rowspan="2">更新</td>
								<td>树种</td>
								<td><el-form-item prop="UpdateTree"><el-input class="pt" v-model="form.UpdateTree"></el-input></el-form-item></td>
								<td>面积(公顷)</td>
								<td><el-form-item prop="UpdateArea"><el-input class="pt" v-model="form.UpdateArea"></el-input></el-form-item></td>
								<td>株数</td>
								<td><el-form-item prop="UpdatePlantNumber"><el-input class="pt" v-model="form.UpdatePlantNumber"></el-input></el-form-item></td>
								<td>方式</td>
								<td colspan="2"><el-form-item prop="UpdateOrigin"><el-input class="pt" v-model="form.UpdateOrigin"></el-input></el-form-item></td>
								<td colspan="2"></td>
							</tr>
							<tr>
								<td colspan="2">完成时间</td>
								<td colspan="2"><el-form-item prop="EndYear"><el-input class="pt" v-model="form.EndYear"></el-input></el-form-item></td>
								<td>年</td>
								<td colspan="2"><el-form-item prop="EndMonth"><el-input class="pt" v-model="form.EndMonth"></el-input></el-form-item></td>
								<td>月</td>
								<td colspan="2"><el-form-item prop="EndDay"><el-input class="pt" v-model="form.EndDay"></el-input></el-form-item></td>
								<td>日</td>
							</tr>
							<tr>
								<td>负责伐区调查设备单位</td>
								<td colspan="4"><el-form-item prop="Designer"><el-input class="pt" v-model="form.Designer"></el-input></el-form-item></td>
								<td>技术负责人姓名</td>
								<td colspan="2"><el-form-item prop="TechnicianName"><el-input class="pt" v-model="form.TechnicianName"></el-input></el-form-item></td>
								<td>联系手机</td>
								<td colspan="3"><el-form-item prop="TechnicianPhone"><el-input class="pt" v-model="form.TechnicianPhone"></el-input></el-form-item></td>
								
							</tr>
							<tr>
								<td>备注</td>
								<td colspan="11"><el-form-item prop="Remarks"><el-input class="pt" v-model="form.Remarks"></el-input></el-form-item></td>
							</tr>
							<tr>
								<td>林地性质</td>
								<td>是否公益林</td>
								<td><el-form-item prop="IsEcoReserves"><el-input class="pt" v-model="form.IsEcoReserves"></el-input></el-form-item></td>
								<td>是否自然保护区</td>
								<td><el-form-item prop="IsNaturalReserve"><el-input class="pt" v-model="form.IsNaturalReserve"></el-input></el-form-item></td>
								<td>是否饮用水源保护区</td>
								<td><el-form-item prop="IsWaterReserve"><el-input class="pt" v-model="form.IsWaterReserve"></el-input></el-form-item></td>
								<td>是否林权抵押</td>
								<td><el-form-item prop="IsForestMortgage"><el-input class="pt" v-model="form.IsForestMortgage"></el-input></el-form-item></td>
								<td colspan="3"></td>
							</tr>
						</tbody>
					</table>
					<div class="flex justify-between margin-top">
						<el-form-item label="图形数据文件："style="flex: 1;">
							<el-upload
								class="upload-demo"
								accept=".zip,.rar"
								action="#"
								:limit="1"
								:on-change="(file) => {handleChange(file, 1)}"
								:on-remove="(file) => {handleRemove(file, 1)}"
								:auto-upload="false"
								:file-list="files"
							>
								<el-button size="small" type="success">点击上传</el-button>
							</el-upload>
						</el-form-item>
						<el-form-item label="资料附件文件："  style="flex: 1;">
							<el-upload
								class="upload-demo"
								accept=".zip,.rar"
								action="#"
								:limit="1"
								:on-change="(file) => {handleChange(file, 2)}"
								:on-remove="(file) => {handleRemove(file, 2)}"
								:auto-upload="false"
								:file-list="files2"
							>
								<el-button size="small" type="success">点击上传</el-button>
							</el-upload>
						</el-form-item>
					</div>
					<div class="flex justify-between">
						<el-form-item label="检疫文件："   style="flex: 1;">
							<el-upload
								class="upload-demo"
								accept=".zip,.rar"
								action="#"
								:limit="1"
								:on-change="(file) => {handleChange(file, 4)}"
								:on-remove="(file) => {handleRemove(file, 4)}"
								:auto-upload="false"
								:file-list="files4"
							>
								<el-button size="small" type="success">点击上传</el-button>
							</el-upload>
						</el-form-item>
					</div>
					<div class="flex justify-between">
						<el-form-item label="优先审批佐证材料：" style="flex: 1;">
							<el-upload
								class="upload-demo"
								accept=".zip,.rar"
								action="#"
								:limit="1"
								:on-change="(file) => {handleChange(file, 5)}"
								:on-remove="(file) => {handleRemove(file, 5)}"
								:auto-upload="false"
								:file-list="files5"
							>
								<el-button size="small" type="success">点击上传</el-button>
							</el-upload>
						</el-form-item>
						<div class="flex-sub"></div>
					</div>
					<div class="confirmAdd">
						<el-button type="success" @click="handleAdd">确 定</el-button>
					</div>
				</el-form>
				</el-scrollbar>
			</div>
		</template>
	</div>
</template>

<script>
import {GetlicenceApproveDetails2,Edit} from '@/api/approveManage'
import {GetFlowchartSelectionBox2} from '@/api/Flowchart'
import {Add2,GetDetaile2,Examine}  from "@/api/Ordered";
import {getCutLicenseDetails}  from "@/api/CutLicense";
import {GetAreaListByPId2} from '@/api/area'
import { baseUrl2 } from '@/static/utils/lyconfig';
import request from '@/utils/axios';
import {DownFiles} from '@/api/file'
import showImages from '@/components/showImage'
export default {
	name: 'Dialog',
	components: {
		showImages
	},
	props: {
		/* 当前类型 */
		currentType: {
			type: String,
			default: 'add'
		},
	},
	data() {
		let validatePhone = (rule,value,callback)=>{
		  if (!value){
		    callback(new Error('手机号不能为空！'));
		  }else{
				callback()
			}
		//使用正则表达式进行验证手机号码
			if (!/^1[3456789]\d{9}$/.test(value)){
				callback(new Error('手机号不正确！'));
		  }else{
				callback()
			}
		}
		let validateNumber = (rule, value, callback) => {
		  if (!value) return callback(new Error('该项不能为空'))
		  if (!Number(value)) return callback(new Error('请输入数字值'))
		  let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
		  if (!reg.test(value)) return callback(new Error('请输入正确值(数字或小数)'));
		  callback();
		}
		let validateNumber2 = (rule, value, callback) => {
		  if (value && !Number(value)) return callback(new Error('请输入数字值'))
		  let reg = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
		  if (value && !reg.test(value)) return callback(new Error('请输入正确值(数字或小数)'));
		  callback();
		}
		return {
			headers:{"token":JSON.parse(localStorage.getItem("user-token"))},
			action:baseUrl2 + '/api/Ordered/UploadExcel2',
			zhen:[],
			cun:[],
			tun:[],
			FlowchartId:null,//流程表id
			orderedName:'',//项目名称
			ApplicantType:'个人',//申请类型：个人，企业
			FellableType:'林地',//伐区类型
			form:{
				ProjectName:'',//项目名称
				ApplyProvince:'',//向哪一级单位申请了——省
				ApplyCity:'',//向哪一级单位申请了——市
				ApplyRegion:'',//向哪一级单位申请了——区
				ApplyTown:'',//向哪一级单位申请了——乡镇
				LegalPerson:'',//法定代表人姓名
				Province:'',//申请单位/个人地址——省
				City:'',//申请单位/个人地址——市
				Region:'',//申请单位/个人地址——区
				Address:'',//申请单位/个人地址——详细地址
				OwnershipType:'',//林木权属类型
				CountryUnitType:'',//国有单位类型
				WoodType:'',//木材类别
				RealEstateCode:'',//不动产编号
				OtherOwnership:'',//其他林木权属
				Town:'',// 乡/林场
				Village:'',//村/分场
				LinBan:'',//林班/作业区
				XiaoBan:'',//小班
				Toponym:'',//小地名
				East:'',//东
				West:'',//西
				South:'',//南
				North:'',//北
				EastGPS:'',//东GPS
				WestGPS:'',//西GPS
				SouthGPS:'',//南GPS
				NorthGPS:'',//北GPS
				Origin:'',// 起源
				ForestType:'',//森林类别
				SecondTree:'',//二级林种
				AdvantageTree:'',//优势树种
				ForestAge:'',//林龄(年)
				MateriaOutput:'',//出材量
				PlantNumber:'',//株数
				LoggingPurpose:'',//采伐用途
				LoggingType:'',//采伐类型
				LoggingMethod:'',//采伐方式
				AccumulativeStrength:'',//蕾积强度《%)
				TreeOne:'',//树种1
				TreeOneAge:'',//树种1年龄
				TreeOneMateriaOutput:'',//树种1出材量
				TreeOnePlantNumber:'',//树种1株数
				TreeOneAccumulate:'',//树种1蓄积
				TreeTwo:'',//树种2
				TreeTwoAge:'',//树种2年龄
				TreeTwoMateriaOutput:'',//树种2出材量
				TreeTwoPlantNumber:'',//树种2株数
				TreeTwoAccumulate:'',//树种2蓄积
				TreeThree:'',//树种3
				TreeThreeAge:'',//树种3年龄
				TreeThreeMateriaOutput:'',//树种3出材量
				TreeThreePlantNumber:'',//树种3株数
				TreeThreeAccumulate:'',//树种3蓄积
				TreeFour:'',//树种4
				TreeFourAge:'',//树种4年龄
				TreeFourMateriaOutput:'',//树种4出材量
				TreeFourPlantNumber:'',//树种4株数
				TreeFourAccumulate:'',//树种4蓄积
				TotalAccumulate:'',//总蓄积
				TotalMateriaOutput:'',//总出材量
				TotalPlantNumber:'',//总株数
				UpdateTree:'',//(更新) 树种
				UpdateArea:'',//(更新) 面积
				UpdatePlantNumber:'',//(更新) 株数
				UpdateOrigin:'',//(更新) 方式
				EndYear:'',//完成时间年
				EndMonth:'',//完成时间月
				EndDay:'',//完成时间日
				Designer:'',//设计单位
				TechnicianName:'',//技术负责人姓名
				TechnicianPhone:'',//技术负责人手机
				Remarks:'',//备注
				IsEcoReserves:'',//是否是公益林
				IsNaturalReserve:'',//是否是自然保护区
				IsWaterReserve:'',//是否是饮用水源保护区
				IsForestMortgage:'',//是否是林权抵押
				Applicant:'',//申请单位《个人) 名称
				OperatorID:'',//统一社会信用代码(身份证号)
				ContactsName:'',//联系人姓名
				ContactsPhone:'',//联系人手机
				ContactsIdCard:'',//联系人身份证号
				Accumulate:0,//蕾积
				Area:0,//面积
			},
			flowChartList:[],
			rules: {
				RojectName:[{ required: true, message: '请填写项目名称', trigger: 'blur' }],
				FlowchartId:[{ required: true, message: '请选择审批流程', trigger: ['change','blur'] }],
				Applicant:[{ required: true, message: '申请人不能为空', trigger: 'blur' }],
				LegalPerson:[{ required: true, message: '法定代表人名称不能为空', trigger: 'blur' }],
				// applicantPhone:[{ validator: validatePhone, trigger: 'blur' },{required: true}],
				ApplicantID:[{ required: true, message: '申请人身份证或企业信用代码不能为空', trigger: 'blur' }],
				Operator:[{ required: true, message: '请输入实际经营者', trigger: 'blur' }],
				OperatorPhone:[{ validator: validatePhone, trigger: 'blur' },{required: true}],
				OperatorID:[{ required: true, message: '统一社会信用代码(身份证)', trigger: 'blur' }],
				Province:[{ required: true ,message: '省份不能为空', trigger: 'blur' }],
				City:[{ required: true ,message: '市不能为空', trigger: 'blur' }],
				Region:[{ required: true ,message: '区不能为空', trigger: 'blur' }],
				ContactsName:[{ required: true ,message: '联系人不能为空', trigger: 'blur' }],
				ContactsPhone:[{ validator: validatePhone, trigger: 'blur' },{required: true}],
				ContactsIdCard:[{ required: true ,message:'联系人身份证不能为空', trigger:'blur' }],
				// UpdateArea:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				ForestAge:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				MateriaOutput:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				Loggingllethod:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				EndYear:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				EndMonth:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				EndDay:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				Area: [{ required: true ,validator: validateNumber, trigger: 'blur' }],
				Accumulate:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				Town: [{ required: true, message: '请选择乡镇(街道)', trigger: 'change' }],
				Village: [{ required: true, message: '请选择村(社区)', trigger: 'change' }],
				Species:[{ required: true, message: '请填写树种', trigger: 'blur' }],
				TreeOneAge:[{validator: validateNumber2, trigger: 'blur' }],
				TreeOneAccumulate:[{validator: validateNumber2, trigger: 'blur' }],
				TreeOneMateriaOutput:[{validator: validateNumber2, trigger: 'blur' }],
				TreeOnePlantNumber:[{validator: validateNumber2, trigger: 'blur' }],
				TreeTwoAge:[{validator: validateNumber2, trigger: 'blur' }],
				TreeTwoAccumulate:[{validator: validateNumber2, trigger: 'blur' }],
				TreeTwoMateriaOutput:[{validator: validateNumber2, trigger: 'blur' }],
				TreeTwoPlantNumber:[{validator: validateNumber2, trigger: 'blur' }],
				TreeThreeAge:[{validator: validateNumber2, trigger: 'blur' }],
				TreeThreeAccumulate:[{validator: validateNumber2, trigger: 'blur' }],
				TreeThreeMateriaOutput:[{validator: validateNumber2, trigger: 'blur' }],
				TreeThreePlantNumber:[{validator: validateNumber2, trigger: 'blur' }],
				TreeFourAge:[{validator: validateNumber2, trigger: 'blur' }],
				TreeFourAccumulate:[{validator: validateNumber2, trigger: 'blur' }],
				TreeFourMateriaOutput:[{validator: validateNumber2, trigger: 'blur' }],
				TreeFourPlantNumber:[{validator: validateNumber2, trigger: 'blur' }],
				TotalAccumulate:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				TotalMateriaOutput:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
				TotalPlantNumber:[{ required: true ,validator: validateNumber, trigger: 'blur' }],
			},
			SHPPath:[],
			FilePath:[],
			// CuttingPath:[],
			QuarantinePath:[],
			FirstFilePathId:[],
			files: [],
			files2: [],
			files4: [],
			files5:[],
			excelData:[],
			orderId:null,
			approveForm:{},
			radio: 2, //是否通过
			reason: '', //原因
			isFirst: false, //是否优先审批
			applyID:null,
		};
	},
	methods: {
		getFlowChartSelectionBox(){
			GetFlowchartSelectionBox2().then(res=>{
				if(res.data.state==1){
					this.flowChartList =res.data.data
				}
			})
		},
		// 获取所有的乡镇
		getZhen(){
			GetAreaListByPId2(0).then(res=>{
				if(res.data.state==1){
					this.zhen = res.data.data
				}
			})
		},
		// 获取当前乡镇下的村
		getCun(e,isEdit,VillageID){
			if(this.form.Town){
				let key = this.zhen.find(el=>el.id==e).name
				let ids = []
				this.flowChartList.forEach(al=>{
					if(al.name.indexOf(key)!=-1){
						ids.push(al.id)
					}
				})
				if(ids.length>0){
					this.FlowchartId = ids[0]
					ids = []
				}
				GetAreaListByPId2(this.form.Town).then(res=>{
					if(res.data.state==1){
						this.cun = res.data.data
						this.tun = []
						if(!isEdit){
							this.form.Village = ''
						}
						if(VillageID){
							this.form.Village = VillageID
						}
					}
				})
			}	
		},
		// 获取当前村下的屯
		getTun(){
			if(this.form.Village){
				GetAreaListByPId2(this.form.Village).then(res=>{
					if(res.data.state==1){
						this.tun = res.data.data
					}
				})
		  }
		},
		// 下载导入模板
		downLoad(){
			const that = this
			that.loading = true
			let params = {
				type:4,
				token:JSON.parse(localStorage.getItem("user-token")),
				isWorker:JSON.parse(localStorage.getItem("isWorker"))==true?'1':'2'
			}
			DownFiles(params).then(res=>{
					let blob = new Blob([res.data], { type: "application/vnd.ms-excel" }) // response就是接口返回的文件流
					let objectUrl = URL.createObjectURL(blob)
					const link = document.createElement("a")  // 创建a标签
					link.href = objectUrl
					link.download = "林木采伐许可证核发申请表.xlsx"  // 自定义文件名
					link.click() // 下载文件
					URL.revokeObjectURL(objectUrl)  // 释放内存
					that.loading = false
			})
		},
		// 获取审批详情
		getOrderDetail(id){
			this.orderId= id
			GetlicenceApproveDetails2({id}).then(res => {
				if (res.data.state == 1) {
					let data = JSON.parse(res.data.data)
					this.FlowchartId = data.FlowchartId
					this.ApplicantType = data.ApplicantType
					this.FellableType = data.FellableType
					if(data.SHPPaths.length>0){
						this.SHPPath = JSON.parse(data.SHPPath)
						data.SHPPaths.forEach(item=>{
							item.FileAddress = this.$store.state.fileUrl+ item.Id
							this.files.push({name:item.FileName,url:item.FileAddress})
						})
					}
					if(data.FilePaths.length>0){
						this.FilePath = JSON.parse(data.FilePath)
						data.FilePaths.forEach(item=>{
						item.FileAddress = this.$store.state.fileUrl+ item.Id
						this.files2.push({name:item.FileName,url:item.FileAddress})
					})
					}
					if(data.QuarantinePaths.length>0){
						this.QuarantinePath = JSON.parse(data.QuarantinePath)
						data.QuarantinePaths.forEach(item=>{
							item.FileAddress = this.$store.state.fileUrl+ item.Id
							this.files4.push({name:item.FileName,url:item.FileAddress})
						})
					}
					if(data.FirstFilePath.length>0){
						this.FirstFilePathId = JSON.parse(data.FirstFilePathId)
						data.FirstFilePath.forEach(item=>{
							item.FileAddress = this.$store.state.fileUrl+ item.Id
							this.files5.push({name:item.FileName,url:item.FileAddress})
						})
					}
					if(data.IndeedImgess.length > 0){
						let arr = []
						data.IndeedImgess.forEach(item=>arr.push(this.$store.state.imgUrl+ item.Id))
						data.Indeeds = arr
					}
					// this.form = data
					// this.form.Town = this.form.TownId
					// this.form.Village = this.form.VillageId
					// this.form.Group = this.form.GroupId|| 0
					this.approveForm = data
				}
			});
		},
		// 获取预约详情
		getApproveDetail(id){
			this.applyID = id
			GetDetaile2(id).then(res => {
				if (res.data.state == 1) {
					this.approveForm = JSON.parse(res.data.data);
					if(this.approveForm.SHPPaths.length>0){
						this.approveForm.SHPPaths.forEach(item=>item.FileAddress = this.$store.state.fileUrl+ item.Id)
					}
					if(this.approveForm.FilePaths.length>0){
						this.approveForm.FilePaths.forEach(item=>item.FileAddress = this.$store.state.fileUrl+ item.Id)
					}
					if(this.approveForm.FirstFilePath.length>0){
						this.approveForm.FirstFilePath.forEach(item=>item.FileAddress = this.$store.state.fileUrl+ item.Id)
					}
					if(this.approveForm.QuarantinePaths.length>0){
						this.approveForm.QuarantinePaths.forEach(item=>item.FileAddress = this.$store.state.fileUrl+ item.Id)
					}
					if(this.approveForm.IndeedImgess.length > 0){
						let arr = []
						this.approveForm.IndeedImgess.forEach(item=>arr.push(this.$store.state.imgUrl+ item.Id))
						this.approveForm.Indeeds = arr
					}
				}
			});
		},
		/* 对话框取消按钮事件 */
		handleCloseDialog() {
			this.files = []
			this.files2 = []
			this.files4 = []
			this.files5 = []
			this.SHPPath = []
			this.FilePath = []
			// this.CuttingPath = []
			this.QuarantinePath = []
			this.FirstFilePathId = []
			this.FlowchartId =null
			this.$refs.form.resetFields()
			this.$emit('close-dialog', false);
		},
		// 采伐证审批
		handleApproval() {
			if (this.radio == 3 && this.reason == '') {
				return this.$message.error('请填写不通过理由');
			}
			let params = {
				id: this.applyID,
				state: parseInt(this.radio),
				opinion: this.reason,
				isFirst: this.isFirst
			};
			Examine(params).then(res => {
				if (res.data.state == 1) {
					this.$message.success('操作成功');
					this.handleCloseDialog2()
					this.$emit('approve-confirm');
				} else {
					return this.$message.error(res.data.msg);
				}
			});
		},
		// 审批取消
		handleCloseDialog2(){
			this.radio = 2;
			this.reason = '';
			this.isFirst = false;
			this.$emit('close-dialog', false);
		},
		// excel上传成功回调
		success(response, file, fileList){
			if(response.state==1){
				this.form = JSON.parse(response.data)
				this.getCun(this.form.Town,true,this.form.Village)
				this.excelData = []
			}else{
				this.$message.error(response.msg)
				this.excelData = []
			}
			
		},
		// excel上传失败回调
		error(){
			this.$message.error('上传失败')
			this.excelData = []
		},
		handleChange(file, type){
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1)
			const extension2 = testmsg === "zip";
			const extension3 = testmsg === "rar";
			const extension4 = testmsg === "xls";
			const extension5 = testmsg === "xlsx";
			switch (type){
				case 1:
					if (!extension2 && !extension3) {
					  this.$message.warning("请上传zip或rar类型文件!")
						this.files = []
					}else{
						this.files.push({name:file.name,raw:file.raw});
					}
					if(this.currentType=='edit'){
						this.SHPPath = []
					}
					break;
				case 2:
					if (!extension2 && !extension3) {
						this.files2 = []
					  this.$message.warning("请上传zip或rar类型文件!")
					}else{
						this.files2.push({name:file.name,raw:file.raw});
					}
					if(this.currentType=='edit'){
						this.FilePath = []
					}
					break;
				case 4:
					if (!extension2 && !extension3) {
						this.files4 = []
					  this.$message.warning("请上传zip或rar类型文件!")
					}else{
						this.files4.push({name:file.name,raw:file.raw});
					}
					if(this.currentType=='edit'){
						this.QuarantinePath = []
					}
					break;
				case 5:
					if (!extension2 && !extension3) {
						this.files5 = []
					  this.$message.warning("请上传zip或rar类型文件!")
					}else{
						this.files5.push({name:file.name,raw:file.raw});
					}
					if(this.currentType=='edit'){
						this.FirstFilePathId = []
					}
					break;
				case 6:
					if (!extension4 && !extension5) {
						this.excelData = []
					  this.$message.warning("请上传xls或xlsx类型文件!")
					}
					break;
			}
		},
		handleRemove(file,type){
			switch (type){
				case 1:
					this.files = [];
					if(this.currentType=='edit'){
						this.SHPPath = []
					}
					break;
				case 2:
					this.files2 = []
					if(this.currentType=='edit'){
						this.FilePath = []
					}
					break;
				case 4:
					this.files4 = []
					if(this.currentType=='edit'){
						this.QuarantinePath = []
					}
					break;
				case 5:
					this.files5 = []
					if(this.currentType=='edit'){
						this.FirstFilePathId = []
					}
					break;
			}
		},
		// 添加预约
		handleAdd(){
			const that = this;
			if(!that.FlowchartId)
			return that.$message.error('请先选择流程')
			if(that.files.length==0)
			return that.$message.error('请上传图形数据')
			let files=[],files2=[],files4 = [],files5=[];
			that.$refs['form'].validate(async valid => {
				if(valid){
					let success = true
					if(that.files.length>0){
						let formData = new FormData();
						formData.append('files', that.files[0].raw);
						 success = await request({
						    method: 'post',
						    url: baseUrl2 + '/api/Ordered/UploadShp2',
						    headers: { 'Content-Type': 'multipart/form-data', token: that.$store.state.user.Token },
						    data: formData
						   }).then(res => {
						    if (res.status == 200) {
						     if (res.data.state == 1) {
						        files =  JSON.parse(res.data.data)
								return true
						     } else {
								return false
						     }
						    } else {
						        return false
						    }
						   });
					}
					if(!success) return
					if(that.files2.length>0){
						let formData = new FormData();
						formData.append('files', that.files2[0].raw);
						 success = await request({
						    method: 'post',
						    url: baseUrl2 + '/api/Ordered/UploadFiles2',
						    headers: { 'Content-Type': 'multipart/form-data', token: that.$store.state.user.Token },
						    data: formData
						   }).then(res => {
						    if (res.status == 200) {
						     if (res.data.state == 1) {
						      files2 =  JSON.parse(res.data.data)
							  return true
						     } else {
						      return false
						     }
						    } else {
						     return false
						    }
						   });
					}
					if(!success) return
					if(that.files4.length>0){
						let formData = new FormData();
						formData.append('files', that.files4[0].raw);
						 success = await request({
						    method: 'post',
						    url: baseUrl2 + '/api/Ordered/UploadFiles2',
						    headers: { 'Content-Type': 'multipart/form-data', token: that.$store.state.user.Token },
						    data: formData
						   }).then(res => {
						    if (res.status == 200) {
						     if (res.data.state == 1) {
						      files4 =  JSON.parse(res.data.data)
							  return true
						     } else {
						     return false
						     }
						    } else {
						     return false
						    }
						   });
					}
					if(!success) return
					if(that.files5.length>0){
						let formData = new FormData();
						formData.append('files', that.files5[0].raw);
						 success = await request({
						    method: 'post',
						    url: baseUrl2 + '/api/Ordered/UploadFiles2',
						    headers: { 'Content-Type': 'multipart/form-data', token: that.$store.state.user.Token },
						    data: formData
						   }).then(res => {
						    if (res.status == 200) {
						     if (res.data.state == 1) {
						      files5 =  JSON.parse(res.data.data)
							  return true
						     } else {
						     return false
						     }
						    } else {
						     return false
						    }
						   });
					}
					if(!success) return
					let params = {
						projectName:that.form.ProjectName,
						applyProvince:that.form.ApplyProvince,
						applyCity:that.form.ApplyCity,
						applyRegion:that.form.ApplyRegion,
						applyTown:that.form.ApplyTown,
						legalPerson:that.form.LegalPerson,
						city:that.form.City,
						province:that.form.Province,
						region:that.form.Region,
						address:that.form.Address,
						ownershipType:that.form.OwnershipType,
						countryUnitType:that.form.CountryUnitType,
						woodType:that.form.WoodType,
						realEstateCode:that.form.RealEstateCode,
						otherOwnership:that.form.OtherOwnership,
						town:that.form.Town,
						village:that.form.Village,
						linBan:that.form.LinBan,
						xiaoBan:that.form.XiaoBan,
						toponym:that.form.Toponym,
						east:that.form.East,
						west:that.form.West,
						south:that.form.South,
						north:that.form.North,
						eastGPS:that.form.EastGPS,
						westGPS:that.form.WestGPS,
						southGPS:that.form.SouthGPS,
						northGPS:that.form.NorthGPS,
						origin:that.form.Origin,
						forestType:that.form.ForestType,
						secondTree:that.form.SecondTree,
						advantageTree:that.form.AdvantageTree,
						forestAge:parseInt(that.form.ForestAge),	
						materiaOutput:parseFloat(that.form.MateriaOutput),
						plantNumber:parseInt(that.form.PlantNumber) || 0,
						loggingPurpose:that.form.LoggingPurpose,
						loggingType:that.form.LoggingType,
						loggingMethod:that.form.LoggingMethod,
						accumulativeStrength:parseFloat(that.form.AccumulativeStrength) || 0,
						treeOne:that.form.TreeOne,
						treeOneAge:parseFloat(that.form.TreeOneAge) || 0,
						treeOneAccumulate:parseFloat(that.form.TreeOneAccumulate) || 0,
						treeOneMateriaOutput:parseFloat(that.form.TreeOneMateriaOutput) || 0,
						treeOnePlantNumber:parseFloat(that.form.TreeOnePlantNumber) || 0,
						treeTwo:that.form.TreeTwo,
						treeTwoAge:parseFloat(that.form.TreeTwoAge) || 0,
						treeTwoAccumulate:parseFloat(that.form.TreeTwoAccumulate) || 0,
						treeTwoMateriaOutput:parseFloat(that.form.TreeTwoMateriaOutput) || 0,
						treeTwoPlantNumber:parseFloat(that.form.TreeTwoPlantNumber) || 0,
						treeThree:that.form.TreeThree,
						treeThreeAge:parseFloat(that.form.TreeThreeAge) || 0,
						treeThreeAccumulate:parseFloat(that.form.TreeThreeAccumulate) || 0,
						treeThreeMateriaOutput:parseFloat(that.form.TreeThreeMateriaOutput) || 0,
						treeThreePlantNumber:parseFloat(that.form.TreeThreePlantNumber) || 0,
						treeFour:that.form.TreeFour,
						treeFourAge:parseFloat(that.form.TreeFourAge) || 0,
						treeFourAccumulate:parseFloat(that.form.TreeFourAccumulate) || 0,
						treeFourMateriaOutput:parseFloat(that.form.TreeFourMateriaOutput) || 0,
						treeFourPlantNumber:parseFloat(that.form.TreeFourPlantNumber) || 0,
						totalAccumulate:parseFloat(that.form.TotalAccumulate) || 0,
						totalMateriaOutput:parseFloat(that.form.TotalMateriaOutput) || 0,
						totalPlantNumber:parseFloat(that.form.TotalPlantNumber) || 0,
						updateTree:that.form.UpdateTree,
						updateArea:parseFloat(that.form.UpdateArea) ||0,
						updatePlantNumber:parseInt(that.form.UpdatePlantNumber) || 0,
						updateOrigin:that.form.UpdateOrigin,
						endYear:parseInt(that.form.EndYear),
						endMonth:parseInt(that.form.EndMonth),
						endDay:parseInt(that.form.EndDay),
						designer:that.form.Designer,
						technicianName:that.form.TechnicianName,
						technicianPhone:that.form.TechnicianPhone,
						remarks:that.form.Remarks,
						isEcoReserves:that.form.IsEcoReserves,
						isNaturalReserve:that.form.IsNaturalReserve,
						isWaterReserve:that.form.IsWaterReserve,
						isForestMortgage:that.form.IsForestMortgage,
						applicant:that.form.Applicant,
						operatorID:that.form.OperatorID,
						contactsName:that.form.ContactsName,
						contactsPhone:that.form.ContactsPhone,
						contactsIdCard:that.form.ContactsIdCard,
						flowchartId:parseInt(that.FlowchartId),
						accumulate:parseFloat(that.form.Accumulate),
						area:parseFloat(that.form.Area),
						group:that.form.Group||0,
						fellableType:that.FellableType,
						applicantType:that.ApplicantType,
						shpPath:files.length>0?JSON.stringify(files):'',
						filePath:files2.length>0?JSON.stringify(files2):'',
						quarantinePath:files4.length>0?JSON.stringify(files4):'',
						firstFilePath:files5.length>0?JSON.stringify(files5):'',
					}
					Add2(params).then(res=>{
						if(res.data.state == 1){
							that.$message.success('操作成功')
							that.flowchartId =null
							that.files = []
							that.files2 = []
							that.files4 = []
							that.files5 = []
							that.$refs.form.resetFields()
							that.$emit('dialog-add-confirm');
						}else{
							that.$message.error(res.data.msg)
						}
					})
				}else {
					return false;
				}
			})
		},
	}
};
</script>

<style lang="less" scoped>
.condition {
	margin-top: 10px;
	display: flex;
	.item {
		flex: 1;
		display: flex;
		align-items: center;
		.ipt {
			width: 50% !important;
		}
	}
}
.approveBtn {
	position: fixed;
	left: 50%;
	bottom: 20px;
	margin-top:30px;
	text-align: center;
	transform:translateX(50%);
}
.reserveContent {
	height: 100%;
}
.confirmAdd{
	display: flex;
	justify-content: center;
	// margin-top: 30px;
	// position: absolute;
	// bottom: 0;
	// left: 0;
	// right: 0;
	// padding:10px 0;
	// text-align: center;
	// box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
	// z-index: 10;
}
	.xlsTable {
		border-collapse: collapse;
		border: 1px solid gray;
		width: 100%;
		table-layout: fixed;
		font-size:12px;
		th,td {
			border: 1px solid gray;
		}
		th {
			padding: 10px 0;
			font-size: 16px;
		}
		tr{
		  width: 100%;
		  td{
		    text-align: center;
		  }
		}
	}

.avatar {
	width: 50px;
	height: 50px;
	margin-right: 10px;
}
.avatar-uploader /deep/.el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader /deep/.el-upload:hover {
	border-color: #409eff;
}
/deep/.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
}
.startImage,
.endImage {
	position: relative;
	.remake {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100px;
		height: 100px;
		background: rgba(0, 0, 0, 0.5);
		z-index: 5;
		display: none;
		i {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 18px;
			color: #fff;
			z-index: 10;
			cursor: pointer;
		}
	}
}
.startImage:hover .remake {
	display: block;
}
.endImage:hover .remake {
	display: block;
}
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: #000;
	opacity: 0.5;
	z-index: 1;
}
/deep/.el-form-item__content {
		margin-left: 0 !important;
		display: flex;
		line-height: 0;
		margin-bottom: 0!important;
}
/deep/.el-form-item {
		margin-bottom: 0!important;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color:#fff!important;
}
.pt{
	// width: 100px!important;
	/deep/ .el-input__inner {
		height: 20px!important;
		line-height: 20px!important;
		border-radius: 0!important;
		padding: 0!important;
	}
}
</style>
